var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeedometer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9503 16.2497C17.4253 14.7497 18.3337 12.683 18.3337 10.4163C18.3337 5.81634 14.6003 2.08301 10.0003 2.08301C5.40033 2.08301 1.66699 5.81634 1.66699 10.4163C1.66699 12.683 2.56699 14.733 4.03366 16.2413",
    stroke: "#525455",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99978 17.9165C11.5554 17.9165 12.8164 16.6555 12.8164 15.0999C12.8164 13.5443 11.5554 12.2832 9.99978 12.2832C8.44417 12.2832 7.18311 13.5443 7.18311 15.0999C7.18311 16.6555 8.44417 17.9165 9.99978 17.9165Z",
    stroke: "#525455",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.708 10H13.333C14.0163 10 14.583 9.44167 14.583 8.75C14.583 8.06667 14.0163 7.5 13.333 7.5C12.6497 7.5 12.083 8.05833 12.083 8.75V9.375C12.083 9.71667 12.3663 10 12.708 10Z",
    stroke: "#525455",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedometer);
export default __webpack_public_path__ + "static/media/speedometer.0f278614845dc1aa706d67e92ca233b1.svg";
export { ForwardRef as ReactComponent };